import * as z from "zod";

export const validateAutomationDeactivationReason = {
  name: "validateAutomationDeactivationReason" as const,
  input: z.object({ reason: z.string().max(1000) }),
  output: z.object({
    /** False when the text is empty or gibberish rather than a real reason. */
    valid: z.boolean(),
  }),
};
